import { Link, usePage } from "@inertiajs/react"
import { Briefcase, Home, MessageSquare, Search, User } from "lucide-react"

import { t } from "@/lib/i18n"
import { profileHref } from "@/lib/profile-path"
import { cn } from "@/lib/utils"

export function BottomTabBar() {
  const page = usePage()
  const { auth } = page.props

  if (!auth.user) return null

  const profileLink = profileHref(auth.user)

  const tabs = [
    { title: t.navigation.home, href: "/inicio", icon: Home },
    { title: t.navigation.search, href: "/buscar", icon: Search },
    {
      title: t.navigation.opportunities,
      href: "/oportunidades",
      icon: Briefcase,
    },
    { title: t.navigation.messages, href: "/mensajes", icon: MessageSquare },
    { title: t.navigation.profile, href: profileLink, icon: User },
  ]

  return (
    <nav className="safe-area-bottom border-border bg-background fixed right-0 bottom-0 left-0 z-50 border-t md:hidden">
      <div className="flex h-16 items-center justify-around">
        {tabs.map((tab) => {
          const isActive = page.url.startsWith(tab.href)
          const Icon = tab.icon

          return (
            <Link
              key={tab.title}
              href={tab.href}
              className={cn(
                "relative flex flex-col items-center justify-center gap-0.5 px-2 py-1 text-[10px] tracking-wider uppercase",
                isActive
                  ? "text-white"
                  : "text-muted-foreground hover:text-white",
              )}
            >
              {isActive && (
                <div className="bg-krown-accent absolute top-0 left-1/4 h-[3px] w-1/2 rounded-b-full"></div>
              )}
              <Icon className="h-5 w-5" />
              <span>{tab.title}</span>
              {tab.href === "/mensajes" && auth.unread_messages_count > 0 && (
                <span className="bg-krown-accent text-krown-800 absolute top-0 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[9px] font-bold">
                  {auth.unread_messages_count}
                </span>
              )}
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
